import produce from 'immer';

import {
  SET_DATES,
  SET_SELECTED_DATE
} from 'shared/actions/types';

const initialState = {
  dates: [],
  selectedDate: null
}

export default function(state = initialState, action) {
  switch(action.type) {
    case SET_DATES:
      return produce(state, draft => {
        draft.dates = action.payload;
      });

    case SET_SELECTED_DATE:
      return produce(state, draft => {
        draft.selectedDate = action.payload;
      });

    default:
      return state;
  }
}
